// v1.1: the "this photo has a note" marker on a thumbnail. Shared by Capture and
// Detail so the two grids can't drift apart.
//
// Deliberately tiny — a dot, not the text. The point is to see AT A GLANCE which
// of four product shots you already annotated without opening each one; the note
// itself is read in the fullscreen viewer, where there's room for it.

/** Add/remove the note dot on a `.thumb` wrapper. Idempotent. */
export function markThumbNote(wrap: HTMLElement, hasNote: boolean): void {
  const existing = wrap.querySelector('.thumb__note');
  if (!hasNote) {
    existing?.remove();
    return;
  }
  if (existing) return;
  const dot = document.createElement('span');
  dot.className = 'thumb__note';
  dot.setAttribute('aria-label', 'Has a note');
  dot.title = 'Has a note';
  dot.textContent = '✎';
  wrap.appendChild(dot);
}
